import React, { useState, useContext, useEffect } from "react";
import "./GalleryFp.css";
import PageHeader from "./PageHeader";
import { AdminContext } from "./AdminContext";

const GalleryFp = () => {
  const { isAdmin } = useContext(AdminContext);

  const dummyImages = [
    { src: "/images/gallery/gallery2.webp", title: "Dr. Chavan Multispeciality Hospital" },
    { src: "/images/gallery/gallery1.webp", title: "Dr. Saurabh Chavan" },
    { src: "/images/gallery/gallery5.webp", title: "Dr. Shubhada Bahirat-Chavan" },
    { src: "/images/gallery/gallery3.webp", title: "FMAS - Dr. Shubhada Bahirat-Chavan" },
    { src: "/images/gallery/gallery4.webp", title: "FMAS - Dr. Saurabh Chavan" },
    { src: "/images/gallery/gallery6.webp", title: "Sonography Training" },
  ];

  const [galleryImages, setGalleryImages] = useState(dummyImages); // load dummy first
  const [modalType, setModalType] = useState(""); // "add" | "edit" | "delete"
  const [activeIndex, setActiveIndex] = useState(null);
    const [loading, setLoading] = useState(true);
// CMH@2025

  const [newImageFile, setNewImageFile] = useState(null);
  const [newCaption, setNewCaption] = useState("");
  const [preview, setPreview] = useState(null);
  const [editCaption, setEditCaption] = useState("");

  const API_BASE = "http://drchavanhospital.in/chavan_api"; //

  // ------------------------
  // Fetch images from API (replace dummy)
  // ------------------------
  const fetchImages = async () => {
  try {
    const res = await fetch(`${API_BASE}/get.php`);
    const data = await res.json();

    if (data.success && data.images.length > 0) {
      // MERGE dummy + backend images
      setGalleryImages([...dummyImages, ...data.images]);
    } else {
      setGalleryImages(dummyImages); // fallback
    }
  } catch (err) {
    console.error("Failed to fetch images:", err);
    setGalleryImages(dummyImages);
  }
  setLoading(false);
};


  useEffect(() => {
    fetchImages();
  }, []);

  // ------------------------
  // Add Image
  // ------------------------
  const openAddModal = () => setModalType("add");

  const saveNewImage = async () => {
    if (!newImageFile) return alert("Please select an image.");
    if (!newCaption.trim()) return alert("Please enter a caption.");

    const formData = new FormData();
    formData.append("image", newImageFile);
    formData.append("alt", newCaption);

    try {
      const res = await fetch(`${API_BASE}/add.php`, {
        method: "POST",
        body: formData,
        credentials: "include",
      });
      const data = await res.json();
      if (data.success) {
        setGalleryImages(prev => [
          { id: data.id, src: `${API_BASE}/get.php?id=${data.id}`, title: data.title },
          ...prev
        ]);
        closeModal();
      } else {
        alert(data.error || "Failed to upload image");
      }
    } catch (err) {
      console.error(err);
      alert("Error uploading image");
    }
  };

  // ------------------------
  // Edit Caption
  // ------------------------
  const openEditModal = index => {
    setActiveIndex(index);
    setEditCaption(galleryImages[index].title);
    setModalType("edit");
  };

  const saveEditedCaption = async () => {
    const img = galleryImages[activeIndex];

    const formData = new FormData();
    formData.append("id", img.id);
    formData.append("alt", editCaption);

    try {
      const res = await fetch(`${API_BASE}/update.php`, {
        method: "POST",
        body: formData,
        credentials: "include",
      });
      const data = await res.json();
      if (data.success) {
        setGalleryImages(prev =>
          prev.map((i, idx) => (idx === activeIndex ? { ...i, title: editCaption } : i))
        );
        closeModal();
      } else {
        alert(data.error || "Failed to update caption");
      }
    } catch (err) {
      console.error(err);
      alert("Error updating caption");
    }
  };

  // ------------------------
  // Delete Image
  // ------------------------
  const openDeleteModal = index => {
    setActiveIndex(index);
    setModalType("delete");
  };

  const confirmDelete = async () => {
  const img = galleryImages[activeIndex];

  try {
    const res = await fetch(`${API_BASE}/delete.php`, {
      method: "POST",
      body: new URLSearchParams({ id: img.id }),
      credentials: "include",
    });
    const data = await res.json();
    if (data.success) {
      setGalleryImages(prev => prev.filter(i => i.id !== img.id)); // use id instead of index
      closeModal();
    } else {
      alert(data.error || "Failed to delete image");
    }
  } catch (err) {
    console.error(err);
    alert("Error deleting image");
  }
};


  const closeModal = () => {
    setModalType("");
    setActiveIndex(null);
    setNewImageFile(null);
    setNewCaption("");
    setPreview(null);
    setEditCaption("");
  };

  // ------------------------
  // Render
  // ------------------------
  return (
    <div className="gallery-fp-page">
      <PageHeader
        title="Photo Gallery"
        breadcrumbs={["Home", "Gallery"]}
        background="../images/pg.webp"
      />

      <h1 className="fp-title">Photo Gallery</h1>

      {isAdmin && (
        <div className="admin-controls">
          <button className="admin-add-btn" onClick={openAddModal}>Add Image</button>
        </div>
      )}

      <div className="fp-grid">
        {galleryImages.map((img, index) => (
          <div key={img.id || index} className="fp-item">
            <div className="fp-image-wrapper">
              <img src={img.src} alt={img.title} loading="lazy" />
              {isAdmin && (
                <div className="admin-image-controls">
                  <button className="edit-btn" onClick={() => openEditModal(index)}>Edit</button>
                  <button className="delete-btn" onClick={() => openDeleteModal(index)}>Delete</button>
                </div>
              )}
              <div className="fp-caption-overlay">{img.title}</div>
            </div>
          </div>
        ))}
      </div>

      {modalType && (
        <div className="fp-modal-overlay">
          <div className="fp-modal">
            {modalType === "add" && (
              <>
                <h2>Add New Image</h2>
                <label className="modal-file-input">
                  Select Image
                  <input
                    type="file"
                    accept="image/*"
                    onChange={e => {
                      const file = e.target.files?.[0];
                      setNewImageFile(file);
                      if (file) setPreview(URL.createObjectURL(file));
                    }}
                  />
                </label>
                {preview && <img src={preview} alt="Preview" className="modal-preview" />}
                <input
                  type="text"
                  placeholder="Enter caption"
                  className="modal-caption-input"
                  value={newCaption}
                  onChange={e => setNewCaption(e.target.value)}
                />
                <div className="modal-actions">
                  <button className="modal-save" onClick={saveNewImage}>Add</button>
                  <button className="modal-cancel" onClick={closeModal}>Cancel</button>
                </div>
              </>
            )}

            {modalType === "edit" && (
              <>
                <h2>Edit Caption</h2>
                <input
                  type="text"
                  className="modal-caption-input"
                  value={editCaption}
                  onChange={e => setEditCaption(e.target.value)}
                />
                <div className="modal-actions">
                  <button className="modal-save" onClick={saveEditedCaption}>Save</button>
                  <button className="modal-cancel" onClick={closeModal}>Cancel</button>
                </div>
              </>
            )}

            {modalType === "delete" && (
              <>
                <h2>Delete Image</h2>
                <p>Are you sure you want to delete this image?</p>
                <div className="modal-actions">
                  <button className="modal-save delete" onClick={confirmDelete}>Yes, Delete</button>
                  <button className="modal-cancel" onClick={closeModal}>Cancel</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryFp;
